<div class="item-editor-content-container">
    <button class="button-undecorated button-close" (click)="cancelModal()" [attr.aria-label]="'Close Item Editor modal'">
        <cwo-icon [name]="iconNameType.close" [size]="'1.25rem'" class="close-icon" />
    </button>
    <div #itemEditorScrollableWrapper class="scrollable-wrapper" id="item-editor-scrollable-wrapper">
        @if(picture() && picture().src && picture().name !== 'none'){
            <div class="image-header-container">
                <button class="button-undecorated image-header-wrapper" (click)="openImageViewer()">
                    <div [ngStyle]="{'background-image': 'url('+picture().src+')'}" class="image"></div>
                </button>
            </div>
        }
       <cwo-item-editor-header #header [name]="title()" 
            [orderedItem]="tempSelectedOrderedItem()" 
            [orderableItem]="tempSelectedOrderable()"
            [showItemNameOnSpecialSingeStep]="showItemNameOnSpecialSingeStep"
            [surcharge]="currentItemSurcharge()"
        >
                <ng-template #details>
                    <div class="details-content">
                        @for(item of detailItems(); track item){
                            <div class="detail-item">
                                <span class="title">{{item.title}}</span>
                                <span class="body">{{item.body}}</span>
                            </div>
                        }
                    </div>
                </ng-template>
        </cwo-item-editor-header>
        <div id="inner-content">
        @switch (currentContentType()) {
            @case (contentType.editor) {
                @if(tempSelectedOrderable() && tempSelectedOrderedItem()){
                    <div id="editor-content" [@.disabled]="animationDisabled" [@enterAnimation] class="choices-wrapper" [ngStyle]="{'padding': isEmptyBody() ? '0px': undefined, 'gap': isEmptyBody() ? '0px' : undefined}">
                        @if(!isMultiStep && showUnmetRequirementsError){
                            <div class="error-container">
                            <cwo-icon [name]="iconNameType.error" [size]="'1rem'" style="margin-top: 0.25rem;" class="error-icon" />
                            <div class="error-message">
                                {{'modals.special_item_editor.errors.unmet_requirements' | transloco}}
                                <button (click)="viewDetails()" class="undecorated-button show-details-button">
                                    {{'modals.special_item_editor.details.view' | transloco}}
                                    <cwo-icon [name]="iconNameType.arrow" [size]="'0.875rem'" [style.transform]="'rotate(-90deg)'" />
                                </button>
                            </div>
                            
                            </div>
                        }
                        @if(tempSelectedOrderable()!.choices){
                        <cwo-choices [isSpecial]="true" [choices]="tempSelectedOrderable()!.choices" [sizePrices]="tempSelectedOrderable()!.sizePrices"
                            [orderedItem]="tempSelectedOrderedItem()!" [toggleWarningsAfterSubmission]="toggleWarningsAfterSubmission"
                            [orderableItem]="tempSelectedOrderable()!"
                            [firstInvalidChoice]="firstInvalidChoiceAfterSubmission"
                            (updatedSpecialItem)="updateTempItemFromChoices($event)"
                            (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue()"/>
                        }
            
                        @if(!showItemDescription() && (configService.configState().store?.allowCustomerInstructions || tempSelectedOrderable()!.allowWebCustomerInstructions)) {
                            <cwo-special-instructions-accordion
                                [title]="'Add Special Instructions'"
                                [showAlwaysExpandButton]="true"
                                [removeBorder]="true"
                                [description]="itemInstructions"
                                [maxLength]="configService.configState().store?.maxSpecialInstructionsLength"
                                (instructionsChanged)="onInstructionsChange($event)"
                                [itemInstructionsExpanded]="configService.configState().store?.itemInstructionsExpanded ?? false"
                            />
                        }
                    </div>
                }
                
            }

            @case (contentType.itemList) {
                <cwo-special-items-list [@.disabled]="animationDisabled" [@enterAnimation] (itemSelected)="onItemSelected($event)" [specialWizard]="specialWizard()"></cwo-special-items-list>
            }

            @case (contentType.steps) {
                <div class="special-item-editor-steps-wrapper">
                    @if(showUnmetRequirementsError){
                        <div class="error-container">
                        <cwo-icon [name]="iconNameType.error" [size]="'1rem'" style="margin-top: 0.25rem;" class="error-icon" />
                        <div class="error-message">                            {{'modals.special_item_editor.errors.unmet_requirements' | transloco}}
                            <button (click)="viewDetails()" class="undecorated-button show-details-button">
                                {{'modals.special_item_editor.details.view' | transloco}}
                                <cwo-icon [name]="iconNameType.arrow" [size]="'0.875rem'" [style.transform]="'rotate(-90deg)'" />
                            </button>
                        </div>
                        
                        </div>
                    }
                    <cwo-special-item-editor-steps 
                        #specialStepsRef
                        id="steps-content"
                        [@.disabled]="animationDisabled" 
                        [@enterAnimation]
                        [specialWizard]="specialWizard()"
                        (showStepItemList)="handleChangeStep($event)"
                        [highlightInvalidFields]="highlightInvalidFields()"
                        (editStepItem)="handleEdit($event)"
                    />            
                </div>


            }
        }

    </div>
        <cwo-scroll-to-top [scrollContainer]="itemEditorScrollableWrapper"></cwo-scroll-to-top>
    </div>
    <div id="item-editor-footer" class="footer" [style.justifyContent]="showBackButton() || footerError ? 'space-between' : 'end'">
        @if(showBackButton()){
            <button class="button-undecorated button-back" (click)="back()">
                <cwo-icon [name]="iconNameType.arrow" [size]="'0.875rem'" [style.transform]="'rotate(90deg)'" />
                {{'modals.special_item_editor.buttons.back' | transloco}}
            </button>
        } 
        @if(footerError){
            <div class="error-message">
                <cwo-icon [name]="iconNameType.error" [size]="'1rem'" class="error-icon" />
                {{footerError}}
            </div>
        }

        @if(!isMultiStep || currentContentType() !== contentType.itemList){
            <button class="button-accent button-add" 
                cwoAsyncButton 
                [subscription]="loadingSubscription" 
                [loadingText]="buttonText+'...'"
                (click)="handleFooterActionButton()"
            >
            {{currentContentType() === contentType.editor && isMultiStep ? ('modals.special_item_editor.buttons.done' | transloco) : buttonText}}
            </button>
        }
        
    </div>
</div>

